import { PlanViewerLayerDetails } from "../planviewer";
import { IPvLayerMap, OlLayerTypeImplT, PvLayer } from "./pvlayer";

export const IsLayerIMROGML = (
  layer: PlanViewerLayerDetails
): layer is PvLayerIMROGML => {
  return layer.type === "imrogml";
};

export class PvLayerIMROGML extends PvLayer implements IPvLayerMap {
  getOlLayer(_options: Record<string, unknown>): OlLayerTypeImplT {
    throw new Error(`Not implemented for type ${this.type}`);
  }
}
